import React from 'react';
import { Tooltip } from 'antd';
import './index.less';
export default class MiniProgress extends React.Component {
    render() {
        const { target, color = 'rgb(19, 194, 194)', strokeWidth, percent } = this.props;
        return (React.createElement("div", { className: "miniProgress" },
            React.createElement(Tooltip, { title: `目标值: ${target}%` },
                React.createElement("div", { className: "target", style: { left: target ? `${target}%` : undefined } },
                    React.createElement("span", { style: { backgroundColor: color || undefined } }),
                    React.createElement("span", { style: { backgroundColor: color || undefined } }))),
            React.createElement("div", { className: "progressWrap" },
                React.createElement("div", { className: "progress", style: {
                        backgroundColor: color || undefined,
                        width: percent ? `${percent}%` : undefined,
                        height: strokeWidth || undefined,
                    } }))));
    }
}
